import React from 'react';
import { useRegistration } from './RegistrationContext';
export const TopBanner = () => {
  const {
    openPopup
  } = useRegistration();
  return <div className="pt-6 pb-4 px-4 max-w-3xl mx-auto" data-id="element-428" data-mp="25wrq6hf9e4rq">
      <div className="flex items-center justify-center mb-6" data-id="element-429" data-mp="2ax5wnv17p6nn">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs Logo" className="h-14 object-contain" data-id="element-430" data-mp="2avuwe56z6h1a" />
      </div>
      <button onClick={openPopup} className="w-full border-2 border-blue-600 bg-blue-50 py-3 px-4 rounded-lg text-center font-bold text-blue-700 hover:bg-blue-100 transition-colors text-sm md:text-base" data-id="element-431" data-mp="1n7bpnu3kqcbb">
        GRATIS WEBINAR VAN HONDEN GEDRAGSEXPERT - VANDAAG & MORGEN
      </button>
    </div>;
};